<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">T<span class="smallcaps">HE </span>S<span class="smallcaps">TORIES</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// thestoriesofjanegardam_00003.vue?933c156a